<template>
  <MobileButtonActive
    v-if="!subitems.length"
    :route="route"
  />
  <MobileButtonWithSubmenu
    v-else
    :route="route"
    :subitems="subitems"
    :active-group="activeGroup"
    @change-active-group="$emit('change-active-group', $event)"
  />
</template>

<script>
import MobileButtonActive from './mobile-menu-button-active';
import MobileButtonWithSubmenu from './mobile-menu-button-with-submenu';

export default {
  props: {
    route: {
      type: Object,
      default: null,
      required: true,
    },
    subitems: {
      type: Array,
      default: () => [],
      required: false,
    },
    activeGroup: {
      type: String,
      default: '',
    },
  },
  components: { MobileButtonActive, MobileButtonWithSubmenu },
};
</script>
